import { render } from "./uiNavigationUnderlineTabs.vue?vue&type=template&id=0f5964f4"
import script from "./uiNavigationUnderlineTabs.vue?vue&type=script&lang=js"
export * from "./uiNavigationUnderlineTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__